export default function QRCode (props) {

    return (
        <svg stroke={props.stroke || 'transparent'} fill={props.fill || '#000'} className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11">
            <path d="M 0 3 L 0 0 L 3 0 L 3 3 M 1 2 L 2 2 L 2 1 L 1 1 M 4 3 L 4 0 L 7 0 L 7 1 L 5 1 L 5 3 M 8 3 L 8 0 L 11 0 L 11 3 M 9 1 L 9 2 L 10 2 L 10 1 M 6 2 L 7 2 L 7 4 L 9 4 L 9 5 L 6 5 M 0 11 L 0 8 L 3 8 L 3 11 M 1 10 L 2 10 L 2 9 L 1 9 M 10 4 L 11 4 L 11 7 L 7 7 L 7 9 L 6 9 L 6 6 L 10 6 M 11 9 L 9 9 L 9 11 L 8 11 L 8 8 L 11 8 M 11 11 L 11 10 L 10 10 L 10 11 M 7 10 L 7 11 L 4 11 L 4 7 L 2 7 L 2 6 L 5 6 L 5 10 M 1 7 L 0 7 L 0 4 L 5 4 L 5 5 L 1 5"/>
        </svg>
    )

}